export const fallbackReleases = [
 {slug:'zombie',title:'Zombie',releaseType:'single',description:'Dark rock single.',featured:true},
 {slug:'the-last-song',title:'The Last Song',releaseType:'single',description:'Popular release.',featured:true},
 {slug:'legacy',title:'Legacy',releaseType:'single',description:'Legacy.',featured:false},
 {slug:'lies-in-both-ears',title:'Lies in Both Ears',releaseType:'single',description:'Alternative release.',featured:false}
];